export { default } from './modal-rating';
